import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import BadgeIcon from "@mui/icons-material/Badge";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import {
  Autocomplete,
  Checkbox,
  Divider,
  IconButton,
  Input,
  ListItemIcon,
  Menu,
  MenuItem,
  Popover,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";

import "./ChatList.css";
import AssignAgentModal from "./AssignAgentModal";
import Loader from "../Components/Loader";
import WarningDialog from "../Components/WarningDialog";
import formatTime from "../Helper/formatTime";
import SortAgentDown from "../Images/CustomAgentDown.svg";
import SortAgentUp from "../Images/CustomAgentUp.svg";
import SortContactDown from "../Images/CustomContactDown.svg";
import SortContactUp from "../Images/CustomContactUp.svg";
import SortDateDown from "../Images/CustomDateDown.svg";
import SortDateUp from "../Images/CustomDateUp.svg";
import { ReactComponent as DocumentIcon } from "../Images/DocumentIcon.svg";
import facebook from "../Images/facebook.svg";
import { ReactComponent as ImagesIcon } from "../Images/ImagesIcon.svg";
import instagram from "../Images/InstagramIcon.svg";
import livechat from "../Images/LiveChatOngoing.svg";
import whatsapp from "../Images/logos_whatsapp-icon.svg";
import { ReactComponent as VideosIcon } from "../Images/VideosIcon.svg";
import WhatsappBusinessIcon from "../Images/WhatsappBusinessSession.svg";
import { IGManualAssignAgent } from "../Store/Actions/IGAction";
import { MetaManualAssignAgent } from "../Store/Actions/MetaAction";
import { getAgentFilter, getAllAccount } from "../Store/Actions/TicketAction";
import { getChatList, manualAssignAgent } from "../Store/Actions/WABAAction";

import {
  SET_ASSIGNMENT_CHAT_LIST_ID,
  SET_IS_SELECTING_CONTACT,
} from "../Store/Types/AgentTypes";

import { UPDATE_CHAT, UPDATE_CHAT_SINGLE } from "../Store/Types/ChatTypes";

export default function ChatList({
  handleSelect,
  selectedChat,
  setSelectedChat,
  setIsBack,
  joinLiveChat,
  isAssigningChats,
  setIsAssigningChats,
}) {
  const { assignmentChatListID, isSelectingContact } = useSelector(
    (state) => state.agent
  );

  const { myInfo } = useSelector((state) => state.auth);
  const level = myInfo.user.Level;
  const [activeTab, setActiveTab] = useState(0);
  const [agentFilterList, setAgentFilterList] = useState([])
  const [agentToAssign, setAgentToAssign] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElFilterChannel, setAnchorElFilterChannel] = useState(null);
  const [anchorElFilterAgent, setAnchorElFilterAgent] = useState(null);
  const [channels, setChannels] = useState({});
  const [chats, setChats] = useState([]);
  const [chatsToAssign, setChatsToAssign] = useState([]);
  const [sortDir, setSortDir] = useState("desc");
  const [isAgentFilterListLoading, setIsAgentFilterListLoading] = useState(true);
  const [isAssignAgentModalShown, setIsAssignAgentModalShown] = useState(false);

  const [isAssignAgentWarningShown, setIsAssignAgentWarningShown] =
    useState(false);

  const [isAssigning, setIsAssigning] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);

  const [searchValue, setSearchValue] = useState(
    assignmentChatListID ? `#WABA${assignmentChatListID}` : ""
  );

  const [selectedAgentFilter, setSelectedAgentFilter] = useState(null);
  const [selectedChannel, setSelectedChannel] = useState("all");
  const [selectedWABAAccountID, setSelectedWABAAccountID] = useState("");
  const [sortBy, setSortBy] = useState("date");

  const [status, setStatus] = useState(
    /* level === 4 && myInfo.user.AgentTypeName !== "Administrator" // For QA agents, resolved
      ? 0
      : level > 0 // Assigned
        ? -2
        : 1 // All unresolved */

    level > 0 ? -2 : 1 // -2 All unresolved, 1 assigned
  );

  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();

  const {
    chatListIDToUpdate,
    isNewChat,
    updateChat,
    updateChatSingle,
    updateChatContactInfo,
  } = useSelector((state) => state.chat);

  const open = Boolean(anchorEl);
  const openFilterChannel = Boolean(anchorElFilterChannel);
  const openFilterAgent = Boolean(anchorElFilterAgent);

  const chatTypeList =
    /* level === 4 && myInfo.user.AgentTypeName !== "Administrator"
      ? [
          {
            key: "Resolved",
            name: "Resolved",
            load: "close",
            icon: "material-symbols:assignment-turned-in-outline-rounded",
            status: 0,
          },
        ]
      : level > 0 */

    level > 0
      ? [
          {
            key: "All",
            name: "All",
            load: "all",
            icon: "material-symbols:assignment-outline-rounded",
            status: -2,
          },

          {
            key: "Assigned",
            name: "Assigned",
            load: "active",
            icon: "material-symbols:assignment-ind-outline",
            status: 1,
          },

          {
            key: "Unassigned",
            name: "Unassigned",
            load: "unassign",
            icon: "material-symbols:assignment-late-outline",
            status: -1,
          },

          {
            key: "Resolved",
            name: "Resolved",
            load: "close",
            icon: "material-symbols:assignment-turned-in-outline-rounded",
            status: 0,
          },
        ]
      : [
          {
            key: "Assigned",
            name: "Assigned",
            load: "active",
            icon: "material-symbols:assignment-returned-outline-rounded",
            status: 1,
          },

          {
            key: "Resolved",
            name: "Resolved",
            load: "close",
            icon: "material-symbols:assignment-turned-in-outline-rounded",
            status: 0,
          },
        ];

  useEffect(() => {
    if (chats) {
      fetchChatList(
        true,
        selectedChannel,
        status,
        selectedWABAAccountID,
        selectedAgentFilter,
        searchValue,
        sortBy,
        sortDir,
        1,
        true
      );

      assignmentChatListID &&
        dispatch({
          type: SET_ASSIGNMENT_CHAT_LIST_ID,
          payload: "",
        });
    } else {
      // Run loader for first load
      fetchChatList(true, selectedChannel, status);
    }
  }, [updateChat, updateChatContactInfo]);

  useEffect(() => {
    if (chats.length > 0 && chatListIDToUpdate) {
      // Update the specific chat
      getChatList(
        status,
        selectedChannel,
        selectedWABAAccountID,
        searchValue,
        sortBy,
        sortDir,
        page,
        selectedAgentFilter?.AgentID
      ).then((response) => {
        if (response.status && response.data.chats.length > 0) {
          const updatedChat = response.data.chats.find(
            (chat) => chat.ChatListID === String(chatListIDToUpdate)
          );
          
          if (updatedChat) {
            updateSingleChatProperty(String(chatListIDToUpdate), updatedChat, isNewChat);
          }
        }

        // Reset the values
        dispatch({
          type: UPDATE_CHAT_SINGLE,
          payload: { chatListID: null, isNewChat: false },
        });
      });
    }
  }, [updateChatSingle]);

  useEffect(() => {
    getAllAccount(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          setChannels(response.data);
          setIsLoading(false);
        } else {
          toast.error("Error fetching channels", {
            autoClose: 3000,
          });

          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Error fetching channels", {
          autoClose: 3000,
        });

        console.log("err", err);
        setIsLoading(false);
      });

    getAgentFilter(myInfo.user.AgentID)
      .then((response) => {
        if (response.status) {
          setAgentFilterList(response.data);
          setIsAgentFilterListLoading(false);
        } else {
          console.log("error", response.error);
          toast.error("Error fetching agents", { autoClose: 3000 });
          setIsAgentFilterListLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error fetching agents", { autoClose: 3000 });
        setIsAgentFilterListLoading(false);
      });
  }, []);

  const fetchChatList = (
    isFirstLoad,
    channelType,
    status,
    WABAAccountID,
    assignedAgentID,
    search,
    sortBy,
    sortDir,
    page,
    isUpdateChat, // To check if called from effect,
  ) => {
    if (isFirstLoad) {
      !isUpdateChat && setIsLoading(true);
      setPage(1);
    }

    getChatList(
      status,
      channelType,
      WABAAccountID,
      search,
      sortBy,
      sortDir,
      page,
      assignedAgentID?.AgentID,
    )
      .then((response) => {
        if (response.status) {
          if (isFirstLoad) {
            setChats(response.data.chats ? response.data.chats : []);

            if (isSelectingContact) {
              setSelectedChat(response.data.chats.find(
                (chat) => chat.ChatListID === selectedChat.ChatListID
              ));

              dispatch({
                type: SET_IS_SELECTING_CONTACT,
                payload: false,
              });
            }
          } else {
            setChats([...chats, ...response.data.chats]);
          }

          if (selectedChat?.ChatSource === "LIVECHAT") {
            setSelectedChat(
              response.data.chats.find(
                (chat) => chat.ConversationID === selectedChat.ConversationID
              )
            );
          }

          setTotal(response.data.total);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickFilterChannel = (event) => {
    setAnchorElFilterChannel(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseFilterChannel = () => {
    setAnchorElFilterChannel(null);
  };

  const renderIcon = (source) => {
    if (source === "WABA") {
      return WhatsappBusinessIcon;
    } else if (source === "FBCHAT") {
      return facebook;
    } else if (source === "WA") {
      return whatsapp;
    } else if (source === "LIVECHAT") {
      return livechat;
    } else {
      return instagram;
    }
  };

  const renderStatus = (status, source, unreadCount) => {
    let icon;

    if (source === "IG") {
      // Special case for IG
      switch (status) {
        case "sent":
        case "NEW":
          icon = "bi:check";
          break;

        case "delivered":
        case "read":
          icon = "bi:check-all";
          break;

        default:
          // icon = "mingcute:time-fill";
          break;
      }
    } else {
      switch (status) {
        case "sent":
          icon = "bi:check";
          break;

        case "NEW":
          icon = "mingcute:time-fill";
          break;

        case "delivered":
        case "read":
          icon = "bi:check-all";
          break;

        default:
          break;
      }
    }

    return (
      <div className="chat-status">
        <div>
          {status === "failed" ? (
            "Failed"
          ) : (
            <Icon
              color={status === "read" ? "#0343C7" : "#727272"}
              height="20"
              icon={icon}
            />
          )}
        </div>

        {unreadCount > 0 && <div className="unread-count">{unreadCount}</div>}
      </div>
    );
  };

  const renderLastChat = (
    isFromAgent,
    mediaURL,
    message,
    source,
    type,
    isDeleted
  ) => {
    let retval;
    const limit = 26;

    if (source === "FBCHAT" && mediaURL) {
      return (
        <div>
          <VideosIcon alt="VideosIcon" style={{ width: 18, height: 18 }} />
          {message ? message : isFromAgent ? "Media sent" : "Media received"}
        </div>
      );
    }

    if (source === "IG" && isDeleted) {
      return (
        <span className="last-message-contents">
          Message removed by Customer
        </span>
      );
    }

    if (source === "WABA" || source === "LIVECHAT") {
      if (type === "audio") {
        return (
          <div>
            <VideosIcon alt="VideosIcon" style={{ width: 18, height: 18 }} />
            {isFromAgent ? "Audio sent" : "Audio received"}
          </div>
        );
      } else if (type === "image") {
        return (
          <div>
            <ImagesIcon alt="ImagesIcon" style={{ width: 18, height: 18 }} />

            <span className="imagesText">
              {message
                ? message
                : isFromAgent
                ? "Image sent"
                : "Image received"}
            </span>
          </div>
        );
      } else if (type === "sticker") {
        return (
          <div>
            <Icon height="18" icon="fluent:sticker-24-filled" />
            {isFromAgent ? "Sticker sent" : "Sticker received"}
          </div>
        );
      } else if (type === "video") {
        return (
          <div>
            <VideosIcon alt="VideosIcon" style={{ width: 18, height: 18 }} />
            {message ? message : isFromAgent ? "Video sent" : "Video received"}
          </div>
        );
      } else if (type === "document") {
        return (
          <div>
            <DocumentIcon
              alt="DocumentIcon"
              style={{ width: 18, height: 18 }}
            />

            {message
              ? message
              : isFromAgent
              ? "Document sent"
              : "Document received"}
          </div>
        );
      } else if (type === "location") {
        return (
          <div>
            <Icon height="18" icon="mdi:location" />
            {isFromAgent ? "Location sent" : "Location received"}
          </div>
        );
      }
    }

    if (String(message).length > limit) {
      const moreText = message.substring(0, limit) + "...";
      retval = moreText;
    } else {
      retval = message;
    }

    return (
      <span className="last-message-contents">
        {type === "template" ? "Template message sent" : retval}
      </span>
    );
  };

  const renderSortingIcon = () => {
    if (sortDir === "asc" && sortBy === "date") {
      return SortDateUp;
    } else if (sortDir === "asc" && sortBy === "name") {
      return SortContactUp;
    } else if (sortDir === "asc" && sortBy === "agent") {
      return SortAgentUp;
    } else if (sortDir === "desc" && sortBy === "date") {
      return SortDateDown;
    } else if (sortDir === "desc" && sortBy === "name") {
      return SortContactDown;
    } else if (sortDir === "desc" && sortBy === "agent") {
      return SortAgentDown;
    }
  };

  const handleSelectedChat = (chat) => {
    setSelectedChat(chat);
    setIsBack(false);

    // Used on socket event, for notification
    localStorage.setItem("selectedChatID", chat.ChatListID);

    if (chat.ChatSource === "LIVECHAT") {
      joinLiveChat(chat.ConversationID);
    }

    // Update selected chat
    dispatch({
      type: UPDATE_CHAT_SINGLE,
      payload: { chatListID: chat.ChatListID },
    });
  };

  function assignAgent() {
    setIsAssigning(true);

    // Determine which API function to use based on first chatsToAssign ChatSource
    const assignmentFunction =
      chatsToAssign[0]?.ChatSource === "WABA"
        ? manualAssignAgent
        : chatsToAssign[0]?.ChatSource === "IG"
          ? IGManualAssignAgent
          : MetaManualAssignAgent;

    assignmentFunction({
      agentid: agentToAssign.AgentID,
      assignby: myInfo.user.AgentID,
      chatlistid: chatsToAssign?.map((chatToAssign) => chatToAssign.ChatListID),
    })
      .then((response) => {
        if (response.status) {
          toast.success("Chats assigned successfully", { autoClose: 3000 });
          setIsAssigning(false);
          setIsAssignAgentWarningShown(false);
          setIsAssignAgentModalShown(false);
          setAgentToAssign(null);
          setChatsToAssign([]);
          setIsAssigningChats(false);
          dispatch({ type: UPDATE_CHAT });
        } else {
          console.log("error", response.error);
          toast.error("Error assigning chats", { autoClose: 3000 });
          setIsAssigning(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error assigning chats", { autoClose: 3000 });
        setIsAssigning(false);
      });
  }

  function updateSingleChatProperty(chatListID, updatedProperties, isNewChat) {
    if (isNewChat) {
      setChats((prevChats) => {
        // Find the chat to update
        const chatToUpdate = prevChats.find(
          (chat) => chat.ChatListID === chatListID
        );

        if (!chatToUpdate) return prevChats;

        // Create updated chat object
        const updatedChat = { ...chatToUpdate, ...updatedProperties };

        // Filter out the old chat and add updated version to top
        const filtered = prevChats.filter(
          (chat) => chat.ChatListID !== chatListID
        );

        return [updatedChat, ...filtered];
      });
    } else {
      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.ChatListID === chatListID
            ? { ...chat, ...updatedProperties }
            : chat
        )
      );
    }
  }

  function renderResponseStatus(isActive, createdTime) {
    if (isActive) {
      if (moment().diff(moment(createdTime), "minutes") > 60) {
        return (
          <Tooltip arrow placement="top" title="Slow resolve">
            <Icon
              color="#ff0000"
              height="24"
              icon="basil:timer-solid"
              width="24"
            />
          </Tooltip>
        );
      }
    }

    return "";
  }

  function renderCallPermissionStatus(permission) {
    let tooltip, color;

    switch (permission) {
      case "green":
        tooltip = "Permanently allowed";
        color = "#00da1d";
        break;

      case "red":
        tooltip = "Not allowed";
        color = "#ff0000";
        break;

      case "yellow":
        tooltip = "Temporarily allowed";
        color = "#e6cf00";
        break;

      default:
        tooltip = "Not allowed";
        color = "#ff0000";
        break;
    }

    return (
      <Tooltip arrow placement="top" title={tooltip}>
        <Icon
          color={color}
          height="24"
          icon="ic:round-call"
          width="24"
        />
      </Tooltip>
    );
  }

  return (
    <>
      {isAssigningChats ? (
        <div className="selected-chats-to-assign">
          <Tooltip arrow placement="bottom" title="Cancel">
            <IconButton
              onClick={() => {
                setChatsToAssign([]);
                setIsAssigningChats(false);
              }}
            >
              <Icon height="28" icon="tabler:x" />
            </IconButton>
          </Tooltip>

          <p>{chatsToAssign.length} Chats Selected</p>

          <Tooltip arrow placement="bottom" title="Assign agent">
            <IconButton onClick={() => setIsAssignAgentModalShown(true)}>
              <Icon height="28" icon="material-symbols:person-add" />
            </IconButton>
          </Tooltip>
        </div>
      ) : (
        <Tabs
          className="tabs"
          TabIndicatorProps={{
            style: {
              height: "4px",
              backgroundColor: "#808080",
            },
          }}
          value={activeTab}
          variant="fullWidth"
        >
          {chatTypeList.map((item, index) => (
            <Tooltip arrow key={item.status} placement="top" title={item.name}>
              <Tab
                icon={<Icon height="30" icon={item.icon} />}
                onClick={() => {
                  setActiveTab(index);
                  setStatus(item.status);

                  fetchChatList(
                    1,
                    selectedChannel,
                    item.status,
                    selectedWABAAccountID,
                    selectedAgentFilter,
                    searchValue,
                    sortBy,
                    sortDir
                  );
                }}
              />
            </Tooltip>
          ))}
        </Tabs>
      )}

      <div className="list_search">
        <div className="single_button">
          <Tooltip title="Filter list" arrow>
            <IconButton onClick={handleClickFilterChannel} size="small">
              {selectedChannel === "waba" ? (
                <img alt="" src={WhatsappBusinessIcon} height={20} />
              ) : (
                <Icon
                  height="20"
                  icon={
                    selectedChannel === "all"
                      ? "fluent:bubble-multiple-20-filled"
                      : selectedChannel === "wa"
                      ? "logos:whatsapp-icon"
                      : selectedChannel === "fbchat"
                      ? "logos:facebook"
                      : selectedChannel === "ig"
                      ? "skill-icons:instagram"
                      : selectedChannel === "livechat"
                      ? "token:chat"
                      : ""
                  }
                />
              )}
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorElFilterChannel}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            id="Filter_menu"
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={openFilterChannel}
            onClose={handleCloseFilterChannel}
            onClick={handleCloseFilterChannel}
          >
            <MenuItem
              selected={selectedChannel === "all"}
              onClick={() => {
                setSelectedChannel("all");

                fetchChatList(
                  true,
                  "all",
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  sortBy,
                  sortDir
                );
              }}
            >
              <ListItemIcon>
                <Icon height="26" icon="fluent:bubble-multiple-20-filled" />
              </ListItemIcon>
              All
            </MenuItem>

            <MenuItem
              selected={selectedChannel === "wa"}
              onClick={() => {
                setSelectedChannel("wa");

                fetchChatList(
                  true,
                  "wa",
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  sortBy,
                  sortDir
                );
              }}
            >
              <ListItemIcon>
                <Icon height="26" icon="logos:whatsapp-icon" />
              </ListItemIcon>
              WhatsApp
            </MenuItem>

            {channels.waba?.map((channel) => (
              <MenuItem
                key={channel.ID}
                selected={selectedChannel === "waba"}
                onClick={() => {
                  setSelectedChannel("waba");
                  setSelectedWABAAccountID(channel.ID);

                  fetchChatList(
                    true,
                    "waba",
                    status,
                    channel.ID,
                    selectedAgentFilter,
                    searchValue,
                    sortBy,
                    sortDir
                  );
                }}
              >
                <ListItemIcon>
                  <img
                    alt=""
                    src={WhatsappBusinessIcon}
                    height={26}
                    style={{ marginRight: "18px" }}
                  />
                </ListItemIcon>
                {channel.Name}
              </MenuItem>
            ))}

            {channels.facebook?.map((channel) => (
              <MenuItem
                key={channel.FacebookID}
                selected={selectedChannel === "fbchat"}
                onClick={() => {
                  setSelectedChannel("fbchat");

                  fetchChatList(
                    true,
                    "fbchat",
                    status,
                    selectedWABAAccountID,
                    selectedAgentFilter,
                    searchValue,
                    sortBy,
                    sortDir
                  );
                }}
              >
                <ListItemIcon>
                  <Icon height="26" icon="logos:facebook" />
                </ListItemIcon>
                {channel.FacebookName}
              </MenuItem>
            ))}

            {channels.instagram?.map((channel) => (
              <MenuItem
                key={channel.InstagramID}
                selected={selectedChannel === "ig"}
                onClick={() => {
                  setSelectedChannel("ig");

                  fetchChatList(
                    true,
                    "ig",
                    status,
                    selectedWABAAccountID,
                    selectedAgentFilter,
                    searchValue,
                    sortBy,
                    sortDir
                  );
                }}
              >
                <ListItemIcon>
                  <Icon height="26" icon="skill-icons:instagram" />
                </ListItemIcon>
                {channel.InstagramName}
              </MenuItem>
            ))}

            <MenuItem
              selected={selectedChannel === "livechat"}
              onClick={() => {
                setSelectedChannel("livechat");

                fetchChatList(
                  true,
                  "livechat",
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  sortBy,
                  sortDir
                );
              }}
            >
              <ListItemIcon>
                <Icon height="26" icon="token:chat" />
              </ListItemIcon>
              Live Chat
            </MenuItem>
          </Menu>
        </div>

        <div className="single_button">
          <Tooltip title="Filter agent" arrow>
            <IconButton
              onClick={(event) => setAnchorElFilterAgent(event.currentTarget)}
              size="small"
            >
              <Icon
                height="20"
                icon={
                  selectedAgentFilter
                    ? "material-symbols:person-search"
                    : "material-symbols:person-search-outline"
                }
              />
            </IconButton>
          </Tooltip>

          <Popover
            anchorEl={anchorElFilterAgent}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            open={openFilterAgent}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            onClose={() => setAnchorElFilterAgent(null)}
          >
            <div className="agent-filter-popover">
              <Autocomplete
                fullWidth
                loading={isAgentFilterListLoading}
                options={agentFilterList}
                value={selectedAgentFilter}
                getOptionLabel={(option) => option.AgentName}
                onChange={(event, value) => {
                  setSelectedAgentFilter(value);
                  console.log(value);

                  fetchChatList(
                    true,
                    selectedChannel,
                    status,
                    selectedWABAAccountID,
                    value,
                    searchValue,
                    sortBy,
                    sortDir
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Assigned agent" />
                )}
              />
            </div>
          </Popover>
        </div>

        <div className="searchbar_container">
          <SearchOutlined className="search_icon" />

          <Input
            className="searchbar"
            placeholder="Search..."
            disableUnderline={true}
            type="text"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onKeyDown={(e) =>
              e.key === "Enter" &&
              fetchChatList(
                true,
                selectedChannel,
                status,
                selectedWABAAccountID,
                selectedAgentFilter,
                searchValue,
                sortBy,
                sortDir
              )
            }
          />

          {searchValue && (
            <CloseOutlinedIcon
              className="clear_search_icon"
              onClick={() => {
                setSearchValue("");

                fetchChatList(
                  true,
                  selectedChannel,
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  "",
                  sortBy,
                  sortDir
                );
              }}
            />
          )}
        </div>

        <div
          className="single_button"
          style={{ border: "none", boxShadow: "none" }}
        >
          <Tooltip title="Sort list" arrow>
            <IconButton onClick={handleClick} size="small">
              <img alt="" src={renderSortingIcon()} height={26} />
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorEl}
            id="Filter_menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                setSortDir("asc");

                fetchChatList(
                  true,
                  selectedChannel,
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  sortBy,
                  "asc"
                );
              }}
              selected={sortDir === "asc"}
            >
              <ListItemIcon>
                <ArrowDropUpIcon />
              </ListItemIcon>
              Ascending
            </MenuItem>

            <MenuItem
              onClick={() => {
                setSortDir("desc");

                fetchChatList(
                  true,
                  selectedChannel,
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  sortBy,
                  "desc"
                );
              }}
              selected={sortDir === "desc"}
            >
              <ListItemIcon>
                <ArrowDropDownIcon />
              </ListItemIcon>
              Descending
            </MenuItem>

            <Divider />

            <MenuItem
              onClick={() => {
                setSortBy("date");

                fetchChatList(
                  true,
                  selectedChannel,
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  "date",
                  sortDir
                );
              }}
              selected={sortBy === "date"}
            >
              <ListItemIcon>
                <CalendarMonthIcon />
              </ListItemIcon>
              By Date
            </MenuItem>

            <MenuItem
              onClick={() => {
                setSortBy("name");

                fetchChatList(
                  true,
                  selectedChannel,
                  status,
                  selectedWABAAccountID,
                  selectedAgentFilter,
                  searchValue,
                  "name",
                  sortDir
                );
              }}
              selected={sortBy === "name"}
            >
              <ListItemIcon>
                <BadgeIcon />
              </ListItemIcon>
              By Name
            </MenuItem>

            {level > 0 ? (
              <MenuItem
                onClick={() => {
                  setSortBy("agent");

                  fetchChatList(
                    true,
                    selectedChannel,
                    status,
                    selectedWABAAccountID,
                    selectedAgentFilter,
                    searchValue,
                    "agent",
                    sortDir
                  );
                }}
                selected={sortBy === "agent"}
              >
                <ListItemIcon>
                  <SupportAgentIcon />
                </ListItemIcon>
                By Agent
              </MenuItem>
            ) : (
              ""
            )}
          </Menu>
        </div>
      </div>

      <div className="chat-list" id="infiniteScrollTarget">
        {isLoading ? (
          <Loader />
        ) : (
          <InfiniteScroll
            className="infinite-scroll"
            dataLength={chats.length}
            endMessage={
              <div className="end-message">
                <b>End of list</b>
              </div>
            }
            hasMore={chats.length < total}
            loader={<Loader />}
            next={() => {
              fetchChatList(
                false,
                selectedChannel,
                status,
                selectedWABAAccountID,
                selectedAgentFilter,
                searchValue,
                sortBy,
                sortDir,
                page + 1
              );

              setPage(page + 1);
            }}
            scrollableTarget="infiniteScrollTarget"
            scrollThreshold={0.9}
          >
            {chats.length > 0 ? (
              chats.map((chat) => (
                <div
                  className={`chat-list-item ${
                    chat.ChatSource === "FBCHAT"
                      ? chat.ChatListID + chat.Session ===
                        selectedChat?.ChatListID + selectedChat?.Session
                        ? "selected"
                        : ""
                      : chat.ChatListID === selectedChat?.ChatListID
                        ? "selected"
                        : ""
                  }`}
                  key={chat.ChatListID}
                  onClick={() => {
                    handleSelectedChat(chat);

                    chat.ChatSource === "WA" &&
                      handleSelect(
                        chat.ChatListID,
                        chat.NotReadCount,
                        chat.Session,
                        chat.MobileNo,
                        chat.IsActive
                      );
                  }}
                >
                  {isAssigningChats &&
                    (chat.ChatSource === "WABA" ||
                      chat.ChatSource === "IG" ||
                      chat.ChatSource === "FBCHAT") && (
                      <Checkbox
                        checked={chatsToAssign.some(
                          (c) => c.ChatListID === chat.ChatListID
                        )}
                        disabled={
                          chatsToAssign.length
                            ? chatsToAssign[0].ChatSource !== chat.ChatSource
                            : false
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            // Add
                            setChatsToAssign([...chatsToAssign, chat]);
                          } else {
                            // Remove
                            setChatsToAssign(
                              chatsToAssign.filter(
                                (chatToAssign) =>
                                  chatToAssign.ChatListID !== chat.ChatListID
                              )
                            );
                          }
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    )}

                  <div className="chat-list-item-contents">
                    <div className="chat-info">
                      <div className="contact-info">
                        <img
                          src={renderIcon(chat.ChatSource)}
                          alt=""
                          style={{ width: 26, height: 26 }}
                        />

                        <span className="contact-name">
                          {chat.ContactName
                            ? chat.ContactName
                            : chat.ProfileName
                              ? chat.ProfileName
                              : "Unknown Contact"}

                          {chat.ChatSource === "LIVECHAT" &&
                            !chat.IsSessionActive &&
                            " (Ended)"}
                        </span>
                      </div>

                      {(chat.ChatSource === "WABA" ||
                        chat.ChatSource === "LIVECHAT") && (
                        <span className="account-info">{chat.Session}</span>
                      )}
                    </div>

                    <div className="last-message-info">
                      <span className="last-message-contents">
                        {renderLastChat(
                          chat.MessageFrom === "AGENT",
                          chat.MediaUrl ? chat.MediaUrl : null,
                          chat.BodyText,
                          chat.ChatSource,
                          chat.Type,
                          chat.Status === "deleted"
                        )}
                      </span>

                      <span className="message-time">
                        {formatTime(
                          chat.Status === "deleted"
                            ? chat.StatusTime
                            : chat.CreatedTime
                        )}
                      </span>
                    </div>

                    <div className="agent-campaign-info">
                      <div className="agent-info">
                        {level > 0 && (
                          <>
                            <Icon
                              icon="material-symbols:support-agent"
                              color="#727272"
                              width="18"
                              height="18"
                              style={{ paddingRight: "4px" }}
                            />

                            <p className="agent-name">
                              {chat.AgentName ? chat.AgentName : "Not Assigned"}
                            </p>
                          </>
                        )}
                      </div>

                      {renderStatus(
                        chat.Status,
                        chat.ChatSource,
                        chat.NotReadCount
                      )}
                    </div>

                    <div className="tags-and-markers">
                      {chat.Tags && (
                        <Tooltip
                          arrow
                          placement="bottom"
                          title={chat.Tags.map((tag) => (
                            <div className="tags-tooltip">
                              <p
                                key={tag.id}
                                style={{
                                  backgroundColor: tag.color ?? "lightgray",
                                }}
                              >
                                {tag.name}
                              </p>
                            </div>
                          ))}
                        >
                          <div className="tags">
                            {chat.Tags.slice(0, 3).map((tag) => (
                              <p
                                key={tag.id}
                                style={{
                                  backgroundColor: tag.color ?? "lightgray",
                                }}
                              >
                                {tag.name}
                              </p>
                            ))}

                            {chat.Tags.length > 3 && (
                              <span>+{chat.Tags.length - 3}</span>
                            )}
                          </div>
                        </Tooltip>
                      )}

                      <div className="markers">
                        {chat.ChatSource === "WABA" &&
                          renderCallPermissionStatus(chat.Permission)}

                        {renderResponseStatus(chat.IsActive, chat.CreatedTime)}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <span style={{ display: "flex", justifyContent: "center" }}>
                No data found
              </span>
            )}
          </InfiniteScroll>
        )}

        {isAssignAgentModalShown && (
          <AssignAgentModal
            agentToAssign={agentToAssign}
            onClose={() => {
              setIsAssignAgentModalShown(false);
              setAgentToAssign(null);
            }}
            setAgentToAssign={setAgentToAssign}
            setIsAssignAgentWarningShown={setIsAssignAgentWarningShown}
          />
        )}

        <WarningDialog
          confirmAction={assignAgent}
          contents={
            <>
              <p>
                You are about to assign these chats to{" "}
                <span>{agentToAssign?.AgentName}</span>.
              </p>

              <p>Are you sure?</p>
            </>
          }
          isOpen={isAssignAgentWarningShown}
          isProcessing={isAssigning}
          setIsOpen={setIsAssignAgentWarningShown}
        />
      </div>
    </>
  );
}
